import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DoLogout } from "../Utils";

export default function ExaminationList(props) {
  const ls = require("localstorage-ttl");
  const [isLoading, setLoading] = useState(false);

  const dbFormat = "YYYY-MM-DD";
  const displayFormat = "DD/MM/YYYY";
  var moment = require("moment");

  const [reserveInstructions, setReserveInstructions] = useState(null);
  const [virtualExamInstructions, setVirtualExamInstructions] = useState(null);
  const [accountDataFaa, setAccountDataFaa] = useState(null);
  const [teachers, setTeachers] = useState([]);
  const [dates, setDates] = useState([]);

  useEffect(() => {
    const token = JSON.parse(ls.get("jwt"));

    const headerRequest = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const datesGet = () => {
      const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

      setLoading(true);
      const config = JSON.parse(ls.get("config"));
      setReserveInstructions(
        config.reserveInstructions?.replace(/\n/g, "<br/>")
      );
      setVirtualExamInstructions(
        config.virtualExamInstructions?.replace(/\n/g, "<br/>")
      );
      setAccountDataFaa(config.accountDataFAA?.replace(/\n/g, "<br/>"));

      const teachers = JSON.parse(ls.get("teachers"));
      setTeachers(teachers);

      const dateFrom = moment().format(dbFormat);
      axios
        .get(
          `${API_URL}/examinations?populate=*&sort[0]=date%3Aasc&sort[1]=rank%3Aasc&filters[date][$gte]=${dateFrom}`,
          headerRequest
        )
        .then((res) => setDates(res.data.data))
        .catch((error) => {
          console.log("Error with examinations:", error);
          if (error.response.status === 401) DoLogout();
        })
        .finally(() => {
          setLoading(false);
        });
    };

    datesGet();
  }, []);

  const renderData = (
    <Table striped hover size="sm" responsive="sm">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Modalidad</th>
          <th>Grado</th>
          <th className="d-none d-md-table-cell">Cupo</th>
          <th>Examinador</th>
          <th className="d-none d-lg-table-cell">Lugar</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody>
        {dates.length < 1 ? (
          <tr>
            <td colSpan="7">Sin reservas.</td>
          </tr>
        ) : (
          dates.map((e) => (
            <tr key={e.id}>
              <td align="center">
                {moment(e.attributes.date).format(displayFormat)}
              </td>
              <td align="center">{e.attributes.mode}</td>
              <td align="center">{e.attributes.rank}</td>
              <td align="center" className="d-none d-md-table-cell">
                {e.attributes.quota}
              </td>
              <td align="left">{e.attributes.examiner.data.attributes.name}</td>
              <td align="left" className="d-none d-lg-table-cell">
                {e.attributes.place?.replace(
                  /(?:https?|ftp):\/\/[\n\S]+/g,
                  "..."
                )}
              </td>
              <td align="center">
                <Link to={`/examination/${e.id}`}>
                  <Button size="sm" variant="success">
                    VER
                  </Button>
                </Link>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3" fluid="lg">
      <h4>RESERVA DE TURNO PARA EXAMEN</h4>
      <p>Seleccione la fecha en la cual desea reservar lugar para examen</p>
      <div
        dangerouslySetInnerHTML={{
          __html: reserveInstructions,
        }}
      ></div>
      <div style={{ textAlign: "left" }}>
        <Accordion
          style={{ maxWidth: "450px", margin: "0 auto" }}
          className="p-1 mb-4"
          flush
        >
          {accountDataFaa && accountDataFaa != "" ? (
            <Accordion.Item eventKey="0">
              <Accordion.Header>Ver CBU Derecho de Exámen</Accordion.Header>
              <Accordion.Body>
                <div
                  dangerouslySetInnerHTML={{
                    __html: accountDataFaa,
                  }}
                ></div>
              </Accordion.Body>
            </Accordion.Item>
          ) : null}
          <Accordion.Item eventKey="1">
            <Accordion.Header>Ver CBU Examinadores</Accordion.Header>
            <Accordion.Body>
              {teachers.map((t) => (
                <p
                  dangerouslySetInnerHTML={{
                    __html: t.attributes.accountInfo?.replace(/\n/g, "<br/>"),
                  }}
                ></p>
              ))}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: virtualExamInstructions,
        }}
      ></div>
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
